import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ClassesDef } from "@app/features/classes/classes";

import { ecommerceApi } from "../api/ecommerce.api";

interface ProductDetailState {
  product: ClassesDef | null;
  loading: boolean;
  error: boolean;
}

const initialState: ProductDetailState = {
  product: null,
  loading: false,
  error: false,
};

export const getProductById = createAsyncThunk(
  "productDetail/getProductById",
  async (id: ClassesDef["id"], { rejectWithValue }) => {
    try {
      const response = await ecommerceApi.getProduct(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data as string);
    }
  }
);

const productDetailSlice = createSlice({
  name: "productDetail",
  initialState,
  reducers: {
    clearProductDetail: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(getProductById.fulfilled, (state, action) => {
      state.loading = false;
      state.product = action.payload;
      state.error = false;
    });

    builder.addCase(getProductById.pending, state => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getProductById.rejected, state => {
      state.loading = false;
      state.error = true;
    });
  },
});

export const { clearProductDetail } = productDetailSlice.actions;

export default productDetailSlice.reducer;
